import { authApi } from '../features/auth/authApi';
import { setAccessToken, setRefreshToken, clearTokens } from './authTokens';

/**
 * Mirrors access_token/refresh_token from successful auth responses into
 * the token store (authTokens.js) so authAxios can attach/rotate them.
 * Token persistence is a side effect and belongs in middleware, not in the
 * authSlice reducer itself.
 */
export const authTokenMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  const establishesSession =
    authApi.endpoints.login.matchFulfilled(action) ||
    authApi.endpoints.verifyTwoFactor.matchFulfilled(action) ||
    authApi.endpoints.consumeMagicLink.matchFulfilled(action) ||
    authApi.endpoints.refresh.matchFulfilled(action);

  if (establishesSession) {
    const payload = action.payload;
    if (payload?.access_token) setAccessToken(payload.access_token);
    if (payload?.refresh_token) setRefreshToken(payload.refresh_token);
  }

  if (authApi.endpoints.logout.matchFulfilled(action) || authApi.endpoints.logout.matchRejected(action)) {
    clearTokens();
  }

  return result;
};

export default authTokenMiddleware;
